import { render } from "./IconText.vue?vue&type=template&id=0243ab23"
import script from "./IconText.vue?vue&type=script&lang=js"
export * from "./IconText.vue?vue&type=script&lang=js"
script.render = render

export default script